import AppConstants from '../../app/config/app.constants';

let ReportService = function ($http, $q) {

    let routePerformance = (startDate, endDate, groupInterval, reverseSort, branch, route, groupBy, limit, offset) => {
        return $http
            .get(AppConstants.api + `/report/route-performance`, {
                params: {
                    startDate,
                    endDate,
                    groupInterval,
                    reverseSort,
                    branch,
                    route,
                    groupBy,
                    limit,
                    offset
                }
            }).then((res) => {
                return res.data
            })
    }

    let routeLocationPerformance = (startDate, endDate, groupInterval, reverseSort, branch, location, groupBy, limit, offset) => {
        return $http
            .get(AppConstants.api + `/report/route-location-performance`, {
                params: {
                    startDate,
                    endDate,
                    groupInterval,
                    reverseSort,
                    branch,
                    location,
                    groupBy,
                    limit,
                    offset
                }
            }).then((res) => {
                return res.data
            })
    }


    let ledgerActivityReport = (startDate, endDate, groupInterval, groupBy, account, branch, fundingSource, currency, denomination, limit, offset) => {
        return $http
            .get(AppConstants.api + `/report/ledger-activity`, {
                params: {
                    startDate,
                    endDate,
                    groupInterval,
                    groupBy,
                    account,
                    branch,
                    fundingSource,
                    currency,
                    denomination,
                    limit,
                    offset
                }
            }).then((res) => {
                return res.data
            })
    }


    let loadCompletedActivity = (startDate, endDate, groupInterval, groupBy, branch, route, fundingSource, location, currency, denomination, limit, offset) => {
        return $http
            .get(AppConstants.api + `/report/load-completed-activity`, {
                params: {
                    startDate,
                    endDate,
                    groupInterval,
                    groupBy,
                    branch,
                    route,
                    fundingSource,
                    location,
                    currency,
                    denomination,
                    limit,
                    offset
                }
            }).then((res) => {
                return res.data
            })
    }

    let deliveryCompletedActivity = (startDate, endDate, groupInterval, groupBy, branch, route, fromLocation, toLocation, shiptype, limit, offset) => {
        return $http
            .get(AppConstants.api + `/report/delivery-completed-activity`, {
                params: {
                    startDate,
                    endDate,
                    groupInterval,
                    groupBy,
                    branch,
                    route,
                    fromLocation,
                    toLocation,
                    shiptype,
                    limit,
                    offset
                }
            }).then((res) => {
                return res.data
            })
    }

    let residualCompletedActivity = (startDate, endDate, groupInterval, groupBy, branch, route, fundingSource, location, currency, denomination, limit, offset) => {
        return $http
            .get(AppConstants.api + `/report/residual-completed-activity`, {
                params: {
                    startDate,
                    endDate,
                    groupInterval,
                    groupBy,
                    branch,
                    route,
                    fundingSource,
                    location,
                    currency,
                    denomination,
                    limit,
                    offset
                }
            }).then((res) => {
                return res.data
            })
    }

    let pickupCompletedActivity = (startDate, endDate, groupInterval, groupBy, branch, route, fromLocation, toLocation, shiptype, limit, offset) => {
        return $http
            .get(AppConstants.api + `/report/pickup-completed-activity`, {
                params: {
                    startDate,
                    endDate,
                    groupInterval,
                    groupBy,
                    branch,
                    route,
                    fromLocation,
                    toLocation,
                    shiptype,
                    limit,
                    offset
                }
            }).then((res) => {
                return res.data
            })
    }


    let bagoutCompletedActivity = (startDate, endDate, groupInterval, groupBy, branch, carrier, fromLocation, toLocation, shiptype, limit, offset) => {
        return $http
            .get(AppConstants.api + `/report/bagout-completed-activity`, {
                params: {
                    startDate,
                    endDate,
                    groupInterval,
                    groupBy,
                    branch,
                    carrier,
                    fromLocation,
                    toLocation,
                    shiptype,
                    limit,
                    offset
                }
            }).then((res) => {
                return res.data
            })
    }

    let serviceOrderCompletedActivity = (startDate, endDate, groupInterval, groupBy, branch, location, route, user, externalProcessor, limit, offset) => {
        return $http
            .get(AppConstants.api + `/report/serviceorder-completed-activity`, {
                params: {
                    startDate,
                    endDate,
                    groupInterval,
                    groupBy,
                    branch,
                    location,
                    route,
                    user,
                    externalProcessor,
                    limit,
                    offset
                }
            }).then((res) => {
                return res.data
            })
    }

    let serviceOrderCancelledActivity = (startDate, endDate, groupInterval, groupBy, branch, location, route, user, externalProcessor, limit, offset) => {
        return $http
            .get(AppConstants.api + `/report/serviceorder-cancelled-activity`, {
                params: {
                    startDate,
                    endDate,
                    groupInterval,
                    groupBy,
                    branch,
                    location,
                    route,
                    user,
                    externalProcessor,
                    limit,
                    offset
                }
            }).then((res) => {
                return res.data
            })
    }

    let userList = (searchText, branch, offset, limit) => {
        return $http
            .get(AppConstants.api + `/report/supervisor-user-list`, {
                params: { searchText, branch, offset, limit }
            })
            .then((res) => {
                return res.data
            })
    };

    let onHoldReport = (searchText, startDate, endDate, routeId, branchId, userId, offset, limit) => {
        return $http
            .get(AppConstants.api + `/report/on-hold-report`, {
                params: { searchText, startDate, endDate, routeId, branchId, userId, offset, limit }
            })
            .then((res) => {
                return res.data
            })
    }

    let exportHoldReport = (searchText, startDate, endDate, routeId, branchId) => {
        return $http
            .post(AppConstants.api + `/report/export-on-hold-report`, {
                    searchText, startDate, endDate, routeId, branchId
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        routePerformance,
        routeLocationPerformance,
        ledgerActivityReport,
        loadCompletedActivity,
        residualCompletedActivity,
        deliveryCompletedActivity,
        pickupCompletedActivity,
        bagoutCompletedActivity,
        serviceOrderCompletedActivity,
        serviceOrderCancelledActivity,
        userList,
        onHoldReport,
        exportHoldReport
    }
}

ReportService.$inject = ["$http", "$q"];

export default ReportService;


// WEBPACK FOOTER //
// ./client/app/services/report.service.js